export default __webpack_public_path__ + "static/1-75c7ac8051477a89eefaff9341c708f7.jpg";